import EditUserPageComponent from "./components/EditUserPageComponent";
import axios from "axios";

const fetchUser = async (userId) => {
    const { data } = await axios.get(`/api/users/${userId}`);
    return data;
}

/*
const updateUserApiRequest = async (userId, name, lastName, email, role, isAdmin, address, city, country, phoneNumber, state, zipCode, password, shippingAddress) => {
    const { data } = await axios.put(`/api/users/${userId}`, { name, lastName, email, role, isAdmin, address, city, country, phoneNumber, state, zipCode, password, shippingAddress });
    return data;
}
*/
const updateUserApiRequest = async (userId, formInputs) => {
    const { data } = await axios.put(`/api/users/${userId}`, { ...formInputs });
    return data;
}

const AdminEditUserPage = () => {
  
  return <EditUserPageComponent updateUserApiRequest={updateUserApiRequest} fetchUser={fetchUser} />;
};

export default AdminEditUserPage;
